import { TAvatar } from "@common";
import { VoiceItemTypes, VoiceTypes } from "./types";

const labelsTranslation = {
	use_case: {
		"social media": "Для социальных сетей",
		news: "Для новостей",
		narration: "Для озвучки и повествования",
		characters: "Для озвучки персонажей (анимация, игры)",
		conversational: "Для естественного общения",
	} as const,
	temper: {
		expressive: "Выразительный",
		confident: "Уверенный",
		soft: "Мягкий",
		upbeat: "Бодрый",
		natural: "Естественный",
		warm: "Тёплый",
		intense: "Энергичный",
		seductive: "Привлекательный",
		articulate: "Разборчивый",
		friendly: "Дружелюбный",
		casual: "Расслабленный",
		deep: "Глубокий",
		authoritative: "Внушающий уважение",
		trustworthy: "Надежный",
	} as const,
};

type UseCaseKey = keyof typeof labelsTranslation.use_case;
type TemperKey = keyof typeof labelsTranslation.temper;

export const translateUseCase = (useCase: string): string => {
	return labelsTranslation.use_case[useCase as UseCaseKey] || `Для ${useCase}`;
};

export const translateTemper = (temper: string): string => {
	return labelsTranslation.temper[temper as TemperKey] || temper;
};

export const filterVoicesByGender = (
	voices: VoiceTypes[],
	gender: string,
): VoiceTypes[] => voices.filter((v) => v.gender === gender);

export const mapVoicesToDropItems = (
	voices: VoiceTypes[],
	onClick: (voice: string) => void,
): VoiceItemTypes[] =>
	voices.map((voice) => ({
		value: voice.voice_id,
		description: voice.name,
		onClick,
		preview_url: voice.preview_url,
		useCase: voice.useCase,
		temper: voice.temper,
}));

export const renderDropTitle = (genderVoices: VoiceTypes[], formData: TAvatar, gender: string): string => {
	const selectedVoice = genderVoices.find((el) => el.voice_id === formData.voice)?.temper || "";
	return selectedVoice
		? `${gender}, ${selectedVoice}`
		: gender;
};